module.exports = __webpack_public_path__ + "static/media/video.4d5811a4.webp";